import { dataDetailListSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDetailListSolid = /*#__PURE__*/createIcon(dataDetailListSolid)
export default IconDetailListSolid
